import type { IHttpClient } from '@/services/api/HttpClient';
import { LoggingHttpService } from '@/services/api/services/logging';

export class HttpLoggingServiceProvider {
  public readonly logging: LoggingHttpService;

  constructor(httpClient: IHttpClient) {
    this.logging = new LoggingHttpService(httpClient);
  }

  static getPwUrl(): string {
    return import.meta.env.VITE_APP_PW_API_PATH || '';
  }
}
